exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recommended-section[data-v-72dd1865] {\n  padding: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  margin-top: 2rem;\n}\n", ""]);

// exports
